import { StyledIcon } from 'fitify-ui/src/Icon/Icon.Styled'
import { colors } from 'fitify-ui/src/theme/colors'
import styled, { css } from 'styled-components'

import { phone } from '../../../theme/breakpoints'

export type StyledRatingHeaderProps = {
  variant: 'desktop' | 'mobile'
}

export const StyledRatingHeader = styled.div<StyledRatingHeaderProps>`
  position: absolute;
  bottom: 120px;
  display: flex;
  flex-direction: row;
  align-items: start;
  margin-top: 48px;
  margin-bottom: 80px;
  gap: 14px;

  ${phone(css`
    position: relative;
    bottom: unset;
    align-self: center;
    order: 5;
    margin-top: 40px;
    margin-bottom: 0;
  `)};

  ${StyledIcon} {
    ${({ variant }) => {
      if (variant === 'mobile') {
        return css`
          width: 143px;
          height: 32px;
          color: ${colors.Black};
        `
      }
      return css`
        width: 163px;
        height: 38px;
        color: ${colors.White};
      `
    }};
  }
`
